import type { Dispatch, SetStateAction } from 'react'
import { useState } from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

import Page from '@/components/layouts/Page'
import type { Breadcrumb } from '@/types/breadcrumb'

export type PortfolioHierarchyPageConfig = {
  title: string
  breadcrumbs: Breadcrumb[]
  pageTag?: string
  /**
   * Retained for child compatibility while the nav now drives section selection via the sidebar.
   * The layout no longer renders in-page tabs.
   */
  activeTab: string
}

type ContextType = {
  pageConfig: PortfolioHierarchyPageConfig | null
  setPageConfig: Dispatch<SetStateAction<PortfolioHierarchyPageConfig | null>>
}

function PortfolioHierarchyLayout() {
  const [pageConfig, setPageConfig] = useState<PortfolioHierarchyPageConfig | null>(null)

  const pageHeaderProps = pageConfig
    ? {
        pageTitle: pageConfig.title,
        breadcrumbItems: pageConfig.breadcrumbs,
        pageTag: pageConfig.pageTag,
      }
    : undefined

  return (
    <Page pageHeaderProps={pageHeaderProps}>
      <Outlet context={{ pageConfig, setPageConfig } satisfies ContextType} />
    </Page>
  )
}

export function usePortfolioHierarchyLayout() {
  return useOutletContext<ContextType>()
}

export default PortfolioHierarchyLayout
